module.exports = __webpack_public_path__ + "img/11088019_L.490420de.png";